import { APIMethod, fetchData } from "@client";

export async function updateWorkspaceNameQuery(uuid, name) {
  const res = await fetchData(`/workspace/${uuid}`, APIMethod.PUT, {
    data: { name }
  });
  
  return res.results;
}
